import { localize } from '../../../util/Localizer'

const createEmptyClaimExpense = (hasCOB = false) => {
  return {
    ClaimLineId: null,
    ServiceDate: '',
    ExtendedHealthCareLineInfo: {
      AmountPaid: 0,
      ReferralOnFile: null,
      ServiceCode: null
    },
    COBField: (hasCOB) ? { originalTo: 'OC', CobAmount: 0 } : null
  }
}

const createEmptyClaimExpenseError = () => {
  return {
    ClaimLineId: '',
    ServiceDate: '',
    ExtendedHealthCareLineInfo: {
      AmountPaid: '',
      ReferralOnFile: '',
      ServiceCode: ''
    },
    COBField: {
      CobAmount: ''
    }
  }
}

const convertCOBAmountForClaimExpense = expense => {
  if (expense.COBField && expense.COBField.CobAmount) {
    expense.COBField.CobAmount = Number(expense.COBField.CobAmount)
  }
}

const validateDateForClaimExpense = (expense, error) => {
  // IMPORTANT: The current implementation of validateDateForClaimExpense allows any string
  // of length greater than zero, except for 'N/A'. It should be updated to validate the
  // date string with a regex.
  const value = expense.ServiceDate
  const isValid = (typeof value === 'string' && value.length > 0 && value !== 'N/A')

  error.ServiceDate = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.ServiceDateValidation')

  return isValid
}

const validateExpenseTypeForClaimExpense = (expense, error) => {
  const value = expense.ExtendedHealthCareLineInfo.ServiceCode
  const isValid = (typeof value === 'object' && value !== null && typeof value.id === 'string' && value.id.length > 0)

  error.ExtendedHealthCareLineInfo.ServiceCode = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.TypeOfExpenseValidation')

  return isValid
}

const validateTotalChargesForClaimExpense = (expense, error) => {
  const value = Number(expense.ExtendedHealthCareLineInfo.AmountPaid)
  const isWithinLimit = (value <= 10000)
  const isValid = (!isNaN(value) && value > 0 && isWithinLimit)

  error.ExtendedHealthCareLineInfo.AmountPaid = (isValid) ? '' : (isWithinLimit) ? localize('pages.SubmitAClaim.Expenses.PaidAmountValidation') : localize('pages.SubmitAClaim.Expenses.limitError')

  return isValid
}

const validateOtherChargesForClaimExpense = (expense, error) => {
  const value = expense.COBField
  let isValid = true

  if (!value || isNaN(Number(value.CobAmount))) {
    isValid = false
    error.COBField.CobAmount = localize('pages.SubmitAClaim.Expenses.noCobError')
  } else if (Number(value.CobAmount) >= Number(expense.ExtendedHealthCareLineInfo.AmountPaid)) {
    isValid = false
    error.COBField.CobAmount = localize('pages.SubmitAClaim.Expenses.cobValidation')
  } else {
    error.COBField.CobAmount = ''
  }

  return isValid
}

const validateClaimExpense = (expense, error, hasCOB = false) => {
  let isValid = true

  isValid = validateDateForClaimExpense(expense, error) && isValid
  isValid = validateExpenseTypeForClaimExpense(expense, error) && isValid
  isValid = validateTotalChargesForClaimExpense(expense, error) && isValid

  if (hasCOB) {
    isValid = validateOtherChargesForClaimExpense(expense, error) && isValid
  }

  return isValid
}

export {
  createEmptyClaimExpense,
  createEmptyClaimExpenseError,
  convertCOBAmountForClaimExpense,
  validateDateForClaimExpense,
  validateExpenseTypeForClaimExpense,
  validateTotalChargesForClaimExpense,
  validateOtherChargesForClaimExpense,
  validateClaimExpense
}



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ManageExpense/functions.js